import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './../_services/auth.service';
import { UserService } from './../_services/user.service';
import decode from 'jwt-decode';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {


  constructor(public authService: AuthService, public router: Router, public userService: UserService,) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean  {

      const token = next.queryParams['token'];
      const encodedData = next.queryParams['data'];

      if (token == "QUhTRVBJQ0FUSEVO1Q==") {
          if (encodedData) {
            try {
              const data = JSON.parse(encodedData);

              const accessToken = data.access_token;
              const userId = data.id;
              //console.log(accessToken,"encodedData",userId)

              localStorage.setItem('access_token', accessToken);
              localStorage.setItem('loggedInUserId', userId);

              console.log('Access Token:', accessToken);
              console.log('User ID:', userId);

            } catch (error) {
              console.error('Error decoding data:', error);
            }
          }
          localStorage.setItem('token', token);
          sessionStorage.setItem('token', token);
        return true; 
        

      } else {
        const storedToken = localStorage.getItem('token'); 
        if (storedToken == "QUhTRVBJQ0FUSEVO1Q==") {
          return true; 
        } 
      }

     
      if (!this.authService.isAuthenticated()) {
        localStorage.clear();
            window.open(this.userService.parentSiteUrl() + "/", "_self");
        // this.router.navigate(['/']);
        return false;
      }
      return true;
  }

}

